import { getActiveSignUpPagePromoBanner, SignUpPagePromoBanners } from '#utils/signUpPage';

import { StatsigMigrationOfferBanner } from './banners/StatsigMigrationOfferBanner/StatsigMigrationOfferBanner';

/* eslint-disable import/no-default-export */
/*
  Steps for adding new banner:
    1. Add new variation to sign-up-page-promo-banner in LaunchDarkly
    2. Update the signUpPagePromoBanner union in packages/dogfood-flags/src/dogfood-flags.ts
    3. Add enum value to SignUpPagePromoBanners in static/ld/utils/signUpPage.ts
    4. Create new banner in static/ld/components/signUp/banners/
    5. Add a new case below for your banner
      ex: case SignUpPagePromoBanners.{variation}: <NewBanner />
    6. Turn on flag
*/

export default function FlagControlledSignUpBannerContainer() {
  const activeBanner = getActiveSignUpPagePromoBanner();

  if (!activeBanner) {
    return null;
  }

  switch (activeBanner) {
    case SignUpPagePromoBanners.statsigMigrationOffer:
      return <StatsigMigrationOfferBanner />;
    default:
      return null;
  }
}
